import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';

import { EventSignUp } from "../type";
import { useState } from 'react';

type SortField = 'name' | 'uid' | 'eventId' | 'eventType' | 'timestamp';
type SortOrder = 'asc' | 'desc';

interface EventParticipantTableProps {
  data: EventSignUp[];
}

const EventParticipantTable = ({ data }: EventParticipantTableProps) => {
  const [sortField, setSortField] = useState<SortField>('timestamp');
  const [sortOrder, setSortOrder] = useState<SortOrder>('desc');

  const handleSort = (field: SortField) => {
    if (sortField === field) {
      // Toggle order if clicking the same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // Set new field with default ascending order
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const sortedData = [...data].sort((a, b) => {
    let compareValue = 0;

    switch (sortField) {
      case 'name':
        compareValue = a.name.localeCompare(b.name, 'ko-KR');
        break;
      case 'uid':
        compareValue = a.uid.localeCompare(b.uid);
        break;
      case 'eventId':
        compareValue = a.eventId.localeCompare(b.eventId);
        break;
      case 'eventType':
        compareValue = a.eventType.localeCompare(b.eventType);
        break;
      case 'timestamp':
        const timeA = a.timestamp?.seconds || 0;
        const timeB = b.timestamp?.seconds || 0;
        compareValue = timeA - timeB;
        break;
    }

    return sortOrder === 'asc' ? compareValue : -compareValue;
  });
  return (
    <Box sx={{ flex: 1, mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        참가자 목록 ({data.length}명)
      </Typography>
      <TableContainer sx={{ maxHeight: 300, overflow: 'auto' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'name'}
                  direction={sortField === 'name' ? sortOrder : 'asc'}
                  onClick={() => handleSort('name')}
                >
                  이름
                </TableSortLabel>
              </TableCell>
              <TableCell>사용자 ID</TableCell>
              <TableCell>이메일</TableCell>
              <TableCell>전화번호</TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'eventId'}
                  direction={sortField === 'eventId' ? sortOrder : 'asc'}
                  onClick={() => handleSort('eventId')}
                >
                  이벤트
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'eventType'}
                  direction={sortField === 'eventType' ? sortOrder : 'asc'}
                  onClick={() => handleSort('eventType')}
                >
                  이벤트 타입
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'timestamp'}
                  direction={sortField === 'timestamp' ? sortOrder : 'asc'}
                  onClick={() => handleSort('timestamp')}
                >
                  신청일시
                </TableSortLabel>
              </TableCell>
              <TableCell>마케팅 동의</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((signUp, index) => (
              <TableRow key={`${signUp.eventId}-${signUp.uid}-${index}`}>
                <TableCell>{signUp.name}</TableCell>
                <TableCell>{signUp.uid}</TableCell>
                <TableCell>{signUp.email}</TableCell>
                <TableCell>{signUp.phone}</TableCell>
                <TableCell>{signUp.eventId}</TableCell>
                <TableCell>{signUp.eventType}</TableCell>
                <TableCell>
                  {signUp.timestamp 
                    ? signUp.timestamp.toDate().toLocaleString('ko-KR')
                    : '-'}
                </TableCell>
                <TableCell>
                  {signUp.consentMarketing ? '동의' : '미동의'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EventParticipantTable;